import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { AngularFireAuth } from '@angular/fire/auth';
import { skipWhile, map, take } from 'rxjs/operators';
import { AngularFirestore } from '@angular/fire/firestore';
import { UserStore } from '@core/store/user.store';
import { User } from '@core/auth/_models/user.model';
import { UserQuery } from '@core/query/user.query';

@Injectable({
  providedIn: 'root'
})
export class RoleGuard implements CanActivate {
  constructor(
    private afAuth: AngularFireAuth,
    private fireStore: AngularFirestore,
    private router: Router,
    private query: UserQuery
  ) {
  }

  canActivate(
    route: ActivatedRouteSnapshot
  ): any {
    console.log('Role guard');
    return this.query.user$.pipe(
      skipWhile(user => !user),
      map((user) => {
        console.log(user);
        const type = route.data.type; // 'write', 'read'
        const field = route.data.field; // 'doctors', 'reviews' etc

        if (user.permissions[field] && user.permissions[field][type]) {
          return true;
        }

        console.log(user.permissions);
        if (user.permissions.sales.read) {
          this.router.navigate(['/order-list']);
        } else if (user.permissions.products.read) {
          this.router.navigate(['/partner-products']);
        } else if (user.permissions.member.read) {
          this.router.navigate(['/member']);
        } else {
          this.router.navigate(['/auth/login'])
        }
        return false;
      }), take(1)).toPromise();
  }

}
